
export const ItemSchema = {
    type: "object",
    properties: {
        item: { type: "string", minLength: 2, maxLength: 255 },
        categoryId: { type: "string", minLength: 2 },
        manufacturer: { type: "string", minLength: 1, maxLength: 255 },
        partNo: { type: "string", minLength: 1, maxLength: 255 },
        cost: { type: "number", minimum: 0.001 },
        unit: { type: "string", minLength: 2 },
    },
    additionalProperties: false,
    required: ['item', 'categoryId', 'manufacturer', 'partNo', 'cost', 'unit'],
    errorMessage: {
        required: {
            item: 'Missing (Item Description)',
            categoryId: 'Missing (Catalog)',
            manufacturer: 'Missing (Manufacturer)',
            partNo: 'Missing (Part No)',
            cost: 'Missing (Cost)',
            unit: 'Missing (UoM)',
        },
        properties: {
            cost: "Cost should be >= 0.001",
            item: 'Item Description should be Min:2, Max:255 Chars',
            manufacturer: 'Manufacturer should be Min:2, Max:255 Chars',
            partNo: 'Part No should be max Min:1, Max:255 Chars',
            unit: 'UoM must have Min:2 Chars',
            categoryId: 'Catalog Missing',
        },
    },
}